import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { color } from '../../app/theme';

const useStyles = {
  white: {
    '& svg circle': {
      color: `${color.$7}`,
    },
  },
  grey: {
    '& svg circle': {
      color: `${color.$10}`,
    },
  },
  blue: {
    '& svg circle': {
      color: `${color.$3}`,
    },
  },
};

const Circular = props => {
  const { classes, topic, ...spreadProps } = props;
  return (
    <CircularProgress
      classes={{ root: classes[`${topic}`] }}
      {...spreadProps}
    />
  );
};

Circular.defaultProps = {
  topic: 'white',
};

Circular.propTypes = {
  topic: PropTypes.string,
};

export default withStyles(useStyles)(Circular);
